import React from "react";
import Footer from "./widgets/Footer";
import Navbar from "./widgets/Navbar";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { constants } from "./constants";
import "./App.css";
import ScrollToTopOnRouteChange from "./components/ScrollToTopOnRouteChange";
import ScrollToTop from "./components/ScrollToTop";
import Video from "./screens/Video";

const Home = React.lazy(() => import("./screens/Home"));
const Contact = React.lazy(() => import("./screens/Contact"));
const About = React.lazy(() => import("./screens/About"));
const Portfolio = React.lazy(() => import("./screens/Portfolio"));
const PortfolioCategory = React.lazy(() =>
  import("./screens/PortfolioCategory")
);
const Packages = React.lazy(() => import("./screens/Packages"));
const Plans = React.lazy(() => import("./screens/Plans"));
const Booking = React.lazy(() => import("./screens/Booking"));

const App = () => {
  return (
    <Router>
      <div className="flex flex-col justify-between w-full h-full">
        <div className="w-full h-full">
          <Navbar />
          <ScrollToTopOnRouteChange />
          <div className="mt-24">
            <Routes>
              <Route
                path={constants.route.root}
                element={<Navigate to={constants.route.home} />}
              />
              <Route path={constants.route.home} element={<Home />} />
              <Route path={constants.route.about} element={<About />} />
              <Route path={constants.route.contact} element={<Contact />} />
              <Route path={constants.route.portfolio} element={<Portfolio />} />
              <Route
                path={constants.route.portfolio + "/:id"}
                element={<PortfolioCategory />}
              />
              <Route path={constants.route.packages} element={<Packages />} />
              <Route
                path={constants.route.packages + "/:id"}
                element={<Plans />}
              />
              <Route path={constants.route.booking} element={<Booking />} />
              <Route path={constants.route.video} element={<Video />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </div>
          <ScrollToTop />
        </div>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
